<template>
    <CFormInput
        :model-value="fileModelValue"
        type="file"
        :add-input-classes="addInputClasses"
        :feedback-invalid="invalidFeedback"
        :invalid="invalid"
        @change="updateValue"
    />
</template>

<script>
import { CFormInput } from '@coreui/vue-pro'

export default {
    name: 'DFileInput',
    components: { CFormInput },
    props: {
        isValid: {
            type: Boolean,
            default: null
        },
        invalidFeedback: {
            type: String,
            default: null
        },
        addInputClasses: {
            type: String,
            default: null
        },
        modelValue: {
            type: String,
            default: null
        },
        fileWithErrors: {
            type: Boolean,
            default: false
        }
    },
    emits: ['change', 'resetFileWithErrors'],
    data () {
        return {
            fileModelValue: this.modelValue ?? null
        }
    },
    computed: {
        invalid () {
            return this.isValid === null ? (this.invalidFeedback !== null) : !this.isValid
        }
    },
    updated () {
        if (this.fileWithErrors) {
            this.fileModelValue = null
        }
        this.$emit('resetFileWithErrors')
    },
    methods: {
        updateValue (event) {
            this.$emit('change', event.target.files)
        }
    }
}
</script>
